import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-33" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-34" data-mp="1mb3xextzeule">
        <h2 className="font-heading text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.7rem]" data-id="element-35" data-mp="1r3ncy0c8bzsu">
          This isn't just another radiology ebook
        </h2>
        <p className="mt-0.5 font-body text-[0.74rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.9rem]" data-id="element-36" data-mp="zd92ke3fd5lx">
          It's a ready-to-use visual study system.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-37" data-mp="18dfcxr3ttpgv">
          {differentiators.map(item => <div key={item.title} className="rounded-md border border-navy/10 bg-clinical px-2.5 py-2" data-id="element-38" data-mp="1dd1pdybtz1om">
              <h3 className="font-body text-[0.76rem] font-extrabold text-navy sm:text-[0.88rem]" data-id="element-39" data-mp="2jsceu1l4095n">
                <span aria-hidden="true" data-id="element-40" data-mp="2opuef1d8lc0z">{item.icon}</span> {item.title}
              </h3>
              <p className="mt-0.5 text-[0.74rem] leading-[1.35] text-graphite sm:text-[0.86rem]" data-id="element-41" data-mp="boamq8f1psm1">
                {item.body}
              </p>
            </div>)}
        </div>
        <p className="mt-2 font-body text-[0.72rem] font-extrabold uppercase tracking-wide text-radio sm:text-[0.86rem]" data-id="element-42" data-mp="2mumuulux8w2">
          Less searching. Less confusion. More visual clarity.
        </p>
      </div>
    </section>;
}